import { Analytics } from '@cobliteam/analytics';
import { useTranslation } from '@cobliteam/i18n';
import { Checkbox, FormControl, FormField, FormItem, FormLabel, useFormContext } from '@cobliteam/ui/form';

import type { FormValues } from '../../checklistSchema';

interface ChecklistItemImageAllowedProps {
  index: number;
}

const ChecklistItemImageAllowed = ({ index }: ChecklistItemImageAllowedProps) => {
  const { t } = useTranslation('checklists');
  const { control, setValue } = useFormContext<FormValues>();

  return (
    <FormField control={control} name={`items.${index}.shouldRequestPhotos`}>
      {({ field }) => (
        <FormItem className='flex items-center gap-2.5'>
          <FormControl>
            <Checkbox
              checked={field.value}
              onCheckedChange={(checked) => {
                Analytics.track('Checklist Item Photo Request Changed', {
                  received: checked,
                });

                // Business logic: user can't require photos if the question is not required
                if (checked) {
                  setValue(`items.${index}.required`, true);
                }
                field.onChange(checked);
              }}
            />
          </FormControl>
          <FormLabel>{t('requires_photos_as_response')}</FormLabel>
        </FormItem>
      )}
    </FormField>
  );
};

export default ChecklistItemImageAllowed;
